//the KPI data report of a selection and a period (PLAN-064): a background job writes the file, the browser downloads it
//through a short-lived link to the storage
export class KPIDataReportRequestDTO {
  kpiIds: number[];

  start: string;

  end: string;

  //1 JSON, 2 Excel; not used by the estimate
  format?: number;

  constructor() {
    this.kpiIds = [];
    this.start = '';
    this.end = '';
  }
}

export class KPIDataReportEstimateDTO {
  points: number;

  evidenceRecords: number;

  evidenceBytes: number;

  constructor() {
    this.points = 0;
    this.evidenceRecords = 0;
    this.evidenceBytes = 0;
  }
}

export class KPIDataReportJobDTO {
  jobId: number;

  //1 Queued, 2 Running, 3 Done, 4 Failed
  status: number;

  format: number;

  kpiIds: number[];

  start: string;

  end: string;

  created: string;

  started: string | null;

  completed: string | null;

  //1 runs next in the tenant; 0 when not queued
  queuePosition: number;

  rowsWritten: number;

  //the estimate at queue time; null when unknown
  rowsTotal: number | null;

  evidenceRows: number;

  fileName: string | null;

  bytes: number | null;

  error: string | null;

  omittedKpiIds: number[];

  //the file is gone (72 hours after the job finished)
  expired: boolean;

  //the library item the file was saved as (PLAN-069); null while not saved
  savedLinkId?: number | null;

  savedListId?: number | null;

  savedFolderName?: string | null;

  constructor() {
    this.jobId = 0;
    this.status = 0;
    this.format = 0;
    this.kpiIds = [];
    this.start = '';
    this.end = '';
    this.created = '';
    this.started = null;
    this.completed = null;
    this.queuePosition = 0;
    this.rowsWritten = 0;
    this.rowsTotal = null;
    this.evidenceRows = 0;
    this.fileName = null;
    this.bytes = null;
    this.error = null;
    this.omittedKpiIds = [];
    this.expired = false;
  }
}

//a read-only link to the one file, valid fifteen minutes; every call issues a new one
export class KPIDataReportDownloadDTO {
  url: string;

  fileName: string;

  expiresOn: string;

  constructor() {
    this.url = '';
    this.fileName = '';
    this.expiresOn = '';
  }
}
